import { resolveEthnicityCode } from "features/patients/utils";

// OCF indication `highRiskEthnicity` must auto-populate to Y when the patient's
// ethnicity is one of the six high-risk groups (HSE spec — CDM-spec.md:1593).
//
// Scope is OCF ONLY. PP has no equivalent field, so it is intentionally out of
// scope (BE-blocked). BE confirmed the FE owns this rule; BE does NOT compute it.
//
// Keyed on the resolved DESCRIPTION (normalised: trimmed + lowercased) rather
// than the code, because the backend ethnic-groups `code` may be a SNOMED code
// or a 2-digit HSE code depending on tenant — the description is stable. This
// mirrors mapEthnicityToQRisk.js.
//
// SNOMED codes for reference: Irish Traveller 315283003, Roma 718958002,
// Black African 18167009, Black Irish 241000220108, Other Black 315279003,
// Other Asian 315281001.
const HIGH_RISK_DESCRIPTIONS = new Set([
  "irish traveller",
  "roma",
  "black african",
  "black irish",
  "other black",
  "other asian",
]);

export const isHighRiskEthnicity = (ethnicityCode, ethnicGroups) => {
  const code = resolveEthnicityCode(ethnicityCode, ethnicGroups);
  const description = ethnicGroups?.find(
    (group) => group.code === code
  )?.description;

  if (!description) return false;

  return HIGH_RISK_DESCRIPTIONS.has(description.trim().toLowerCase());
};
